import Home from "../components/Home/Home";

const home = [
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
];

export default home;



// WEBPACK FOOTER //
// ./src/router/home.js